import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'

export default class VehicleTypeFilter extends Component {
  static propTypes = {
    filter: PropTypes.any,
    onChange: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      vehicleTypes: []
    }
  }

  async componentDidMount () {
    this.setState({loading: true})
    const vehicleTypes = await SostaOnlineApiService.fetchVehicleOwnershipTypes()
    this.setState({
      vehicleTypes: vehicleTypes.data,
      loading: false
    })
  }

  render () {
    const {filter, onChange} = this.props
    const {loading, vehicleTypes} = this.state

    if (loading) {
      return (
        <div className="text-info">Caricamento in corso...</div>
      )
    }

    return (
      <select
        onChange={event => onChange(event.target.value)}
        style={{ width: '100%' }}
        value={filter ? filter.value : ''}
      >
        <option value="">Tutti</option>
        {vehicleTypes.map((item, index) => {
          return (
            <option
              key={item.id + '-' + index}
              value={item.id}>
              {item.name}
            </option>
          )
        })}
      </select>
    )
  }
}
